import { jsx as t } from "react/jsx-runtime";
import { useEffect as m } from "react";
import a from "./index.es2467.js";
import { parseNewItemsObject as u, expandVisibleItems as E } from "./index.es76.js";
import { BASIC_MENU_ITEM_HEIGHT as M } from "./index.es83.js";
import { Tree as x } from "./index.es2468.js";
const b = ({
  items: r,
  setItems: o,
  onItemSelect: l,
  maxVisibleItems: f,
  expandAllItems: c,
  singleSelectMode: e,
  searchTerm: i,
  expandOnSearch: p = !1,
  ...n
}) => {
  m(() => {
    u(r, o);
  }, [r, o]), m(() => {
    p && i !== "" && E(o);
  }, [p, i, o]);
  const H = f ? f * M : 280;
  return /* @__PURE__ */ t("div", { className: a.root, style: { maxHeight: H }, children: /* @__PURE__ */ t(
    x,
    {
      items: r,
      setItems: o,
      onItemSelect: l,
      expandAllItems: c,
      singleSelectMode: e,
      searchTerm: i,
      ...n
    }
  ) });
};
export {
  b as HierarchicalMenu
};
//# sourceMappingURL=index.es74.js.map
